var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('static-header'),_c('notifications',{staticClass:"vue-notification-style",attrs:{"group":"success","position":"top left"}}),_c('notifications',{staticClass:"vue-notification-style",attrs:{"group":"error","position":"top left"}}),_c('router-view'),_c('static-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }